import { ContentItemProperties } from '@/data/types/Slot';

const contentItems: ContentItemProperties[] = [
    { emsName: 'IT-LEGO-Loyalty-Shopcart-Image-eSpot' },
    { emsName: 'IT-LEGO-Loyalty-AccountNumber-Info-Link-eSpot' },
    { emsName: 'Order_Confirmation_Page_Lego_Card_Text_eSpot' },
    { emsName: 'Loyalty_Info_Popup_Image_eSpot' }
];
export default contentItems;